import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { Login } from './screens/Login';
import { Home } from './screens/Home';
import { TOKEN, COMPANY_LOGO } from './constant';
import { useTimecampService } from './services/timecamp.service';
import logo from './logo.svg';
import './App.css';

function App() {
  const { verifyLogin } = useTimecampService();
  const [route, setRoute] = useState<string>('login');
  const [companyLogo, setCompanyLogo] = useState<string | null>(null);

  useEffect(() => {
    const storedLogo = Cookies.get(COMPANY_LOGO);
    if (storedLogo) {
      setCompanyLogo(storedLogo);
    }
    
    if (Cookies.get(TOKEN)) {
      verifyLogin()
        .then(() => {
          setRoute('home');
        })
        .catch((e: Error) => {
          Cookies.remove(TOKEN);
          Cookies.remove(COMPANY_LOGO);
          setCompanyLogo(null);
          console.error(e);
        });
    }
  }, [verifyLogin]);

  const handleLogout = () => {
    Cookies.remove(TOKEN);
    Cookies.remove(COMPANY_LOGO);
    setCompanyLogo(null);
    setRoute('login');
  }

  return (
    <div className="App">
      <Navbar>
        <Container>
          <Navbar.Brand href="#">
            <img
              src={companyLogo || logo}
              height="75"
              className="d-inline-block align-top"
              alt="Timecamp logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle />
          {route !== 'login' ? <Navbar.Collapse className="justify-content-end">
            <Button variant="primary" onClick={handleLogout}>Logout</Button>
          </Navbar.Collapse>
            : null}
        </Container>
      </Navbar>
      <Container fluid="sm">
        <Row className="justify-content-md-center align-items-center" style={{ height: 'calc(100vh - 105px)' }}>
          <Col xs lg="4" md="6">
            {route === 'login' ? <Login setRoute={setRoute} setCompanyLogo={setCompanyLogo} /> : null}
            {route === 'home' ? <Home setRoute={setRoute} /> : null}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
